export const MODAL_ID_BENEFITS = 'ACCEPT_TERM_BENEFIT'
export const breadcrumbList = [
  {
    route: `/meus-beneficios`,
    title: 'Meus benefícios',
  },
  {
    route: `/meus-beneficios/seguro-de-vida`,
    title: 'Seguro de Vida',
  },
  {
    route: `/meus-beneficios/seguro-de-vida/duvidas-frequentes`,
    title: 'Dúvidas frequentes',
  },
]

export const breadcrumbLaboratoriesList = [
  {
    route: `/meus-beneficios`,
    title: 'Meus benefícios',
  },
  {
    route: `/meus-beneficios/laboratorios-parceiros`,
    title: 'Desconto em laboratórios',
  },
]
export const breadcrumbDiscountPharmacies = [
  {
    route: `/meus-beneficios`,
    title: 'Meus benefícios',
  },
  {
    route: `/meus-beneficios/farmacias-desconto`,
    title: 'Desconto em farmácias',
  },
]
